<mat-card fxFlex="100" class="section-card" *ngIf="produtoId">
  <mat-card-title>
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="mr-1">store</mat-icon>
      <span style="margin-left: 8px;">Mercado Livre</span>
      <span fxFlex></span>
      <!-- Saldo do canal: é exatamente a quantidade que a publicação vai enviar. -->
      <span class="ml-saldo" *ngIf="saldo">
        Remessa em aberto: <strong>{{ saldo.qtde | number:'1.0-3' }}</strong>
        <span *ngIf="saldo.preco"> &middot; R$ {{ saldo.preco | number:'1.2-2' }}</span>
      </span>
    </div>
  </mat-card-title>

  <mat-card-content>

    <!-- 1. Sem mapeamento: vincular a um anúncio existente ou preparar um novo. -->
    <div *ngIf="!mapeado && !carregando">
      <p class="ml-hint">Este produto ainda não está mapeado para o Mercado Livre.</p>

      <div fxLayout="row wrap" fxLayoutGap="16px">
        <div fxFlex="45" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Anúncio existente (MLB...)</mat-label>
            <input matInput [(ngModel)]="itemIdInformado" placeholder="MLB1234567890" />
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="vincular()">
            <mat-icon>link</mat-icon> Vincular
          </button>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
          <button mat-stroked-button color="primary" (click)="sugerirCategorias()">
            <mat-icon>search</mat-icon> Sugerir categorias pela descrição
          </button>

          <mat-list *ngIf="sugestoes?.length" dense>
            <mat-list-item *ngFor="let s of sugestoes" (click)="escolherSugestao(s)" class="ml-sugestao"
              [class.ml-sugestao-ativa]="categoriaEscolhida === s.category_id">
              <mat-icon mat-list-icon>category</mat-icon>
              <div mat-line>{{ s.category_name }}</div>
              <div mat-line class="ml-hint">{{ s.category_id }}</div>
            </mat-list-item>
          </mat-list>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Categoria (MLB...)</mat-label>
            <input matInput [(ngModel)]="categoriaEscolhida" placeholder="MLB1234" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Tipo de anúncio</mat-label>
            <mat-select [(ngModel)]="listingTypeId">
              <mat-option *ngFor="let t of tiposAnuncio" [value]="t.valor">{{ t.rotulo }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Condição</mat-label>
            <mat-select [(ngModel)]="condicao">
              <mat-option *ngFor="let c of condicoes" [value]="c.valor">{{ c.rotulo }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-raised-button color="primary" (click)="preparar()">
            <mat-icon>playlist_add</mat-icon> Preparar anúncio
          </button>
        </div>
      </div>
    </div>

    <!-- 2. Mapeado: estado do anúncio. -->
    <div *ngIf="mapeado">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px" class="ml-status">
        <span>
          <strong *ngIf="publicado">
            <a [href]="anuncio.permalink" target="_blank" *ngIf="anuncio.permalink">{{ anuncio.itemId }}</a>
            <span *ngIf="!anuncio.permalink">{{ anuncio.itemId }}</span>
          </strong>
          <em *ngIf="!publicado">Ainda não publicado</em>
        </span>
        <span>Categoria: {{ anuncio.categoryId }}</span>
        <span>Situação: {{ anuncio.status }}</span>
        <span *ngIf="anuncio.qtdePublicada != null">
          No ar: {{ anuncio.qtdePublicada | number:'1.0-3' }} un.
          <span *ngIf="anuncio.precoPublicado"> &middot; R$ {{ anuncio.precoPublicado | number:'1.2-2' }}</span>
        </span>
      </div>

      <!-- O erro do ML é específico e diz o que corrigir; por isso fica visível. -->
      <div *ngIf="anuncio.ultimoErro" class="ml-erro">
        <mat-icon color="warn">error_outline</mat-icon> {{ anuncio.ultimoErro }}
      </div>

      <!-- Lista vazia nao pode sumir em silencio: sem isto, "a categoria nao exige nada" e
           "a consulta ao ML falhou" ficam indistinguiveis na tela. -->
      <div *ngIf="anuncio?.categoryId && !atributos?.length && !carregando" class="ml-atributos">
        <h4>Atributos da categoria</h4>
        <p class="ml-hint">
          A categoria <code>{{ anuncio.categoryId }}</code> não devolveu atributos
          {{ mostrarTodosAtributos ? '' : 'obrigatórios' }}.
          <button mat-button color="primary" (click)="carregarAtributos()">Tentar de novo</button>
          <button mat-button color="primary" (click)="alternarTodosAtributos()">
            {{ mostrarTodosAtributos ? 'Só os obrigatórios' : 'Mostrar todos' }}
          </button>
        </p>
      </div>

      <!-- 3. O que a categoria exige. -->
      <div *ngIf="atributos?.length" class="ml-atributos">
        <h4>
          Atributos da categoria
          <button mat-button color="primary" (click)="alternarTodosAtributos()">
            {{ mostrarTodosAtributos ? 'Só os obrigatórios' : 'Mostrar todos' }}
          </button>
          <small class="ml-hint">
            {{ mostrarTodosAtributos ? 'Obrigatórios (*) primeiro; os ocultos do Mercado Livre não
            aparecem' : 'Os que impedem a publicação' }}
          </small>
        </h4>

        <div fxLayout="row wrap" fxLayoutGap="16px">
          <div fxFlex="30" fxFlex.lt-md="100" *ngFor="let atributo of atributos">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ atributo.nome }}{{ atributo.obrigatorio ? ' *' : '' }}</mat-label>

              <!-- Categoria que restringe os valores vira select; o resto é texto livre. -->
              <mat-select *ngIf="atributo.valoresPermitidos?.length" [(ngModel)]="atributo.valor"
                [disabled]="atributo.origem === 'cadastro'">
                <mat-option [value]="">(vazio)</mat-option>
                <mat-option *ngFor="let v of atributo.valoresPermitidos" [value]="v">{{ v }}</mat-option>
              </mat-select>

              <!-- Texto livre COM sugestao: o ML tem vocabulario para marca e modelo, mas produto
                   de nicho nao esta no catalogo dele. Fechar o campo impediria de anunciar. -->
              <input matInput *ngIf="!atributo.valoresPermitidos?.length" [(ngModel)]="atributo.valor"
                [disabled]="atributo.origem === 'cadastro'"
                [matAutocomplete]="autoAtributo"
                (focus)="carregarSugestoes(atributo)" />
              <mat-autocomplete #autoAtributo="matAutocomplete">
                <mat-option *ngFor="let sugestao of sugestoesPorAtributo[atributo.code]"
                  [value]="sugestao">
                  {{ sugestao }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- Veio do cadastro do produto: editar aqui criaria duas versões do mesmo dado. -->
            <small class="ml-hint" *ngIf="atributo.origem === 'cadastro'">
              Vem do cadastro do produto.
            </small>
          </div>
        </div>

        <button mat-stroked-button color="primary" (click)="salvarAtributos()">
          <mat-icon>save</mat-icon> Salvar atributos
        </button>
      </div>

      <!-- 4. Conferência antes de publicar. -->
      <div *ngIf="validacao" class="ml-validacao">
        <div *ngIf="validacao.pronto" class="ml-ok">
          <mat-icon color="primary">check_circle</mat-icon> Pronto para publicar.
        </div>
        <div *ngIf="!validacao.pronto">
          <strong>Impede a publicação:</strong>
          <ul>
            <li *ngFor="let impedimento of validacao.impedimentos">{{ impedimento }}</li>
          </ul>
        </div>
        <div *ngIf="validacao.avisos?.length" class="ml-avisos">
          <strong>Atenção:</strong>
          <ul>
            <li *ngFor="let aviso of validacao.avisos">{{ aviso }}</li>
          </ul>
        </div>
      </div>

      <!-- 5. Ações. -->
      <div fxLayout="row" fxLayoutGap="8px" class="ml-acoes">
        <button mat-raised-button color="primary" (click)="publicar()"
          [disabled]="publicando || (validacao && !validacao.pronto)">
          <mat-icon>cloud_upload</mat-icon>
          {{ publicado ? 'Sincronizar' : 'Publicar' }}
        </button>
        <button mat-button (click)="carregar()">
          <mat-icon>refresh</mat-icon> Atualizar
        </button>
        <span fxFlex></span>
        <button mat-button color="warn" (click)="desvincular()">
          <mat-icon>link_off</mat-icon> Remover vínculo
        </button>
      </div>
    </div>

  </mat-card-content>
</mat-card>
